import { createContext, useContext } from 'react';

const InteropContext = createContext('');

const useInteropContext = () => useContext(InteropContext);

export default InteropContext;
export { useInteropContext };
